// extracted by mini-css-extract-plugin
module.exports = {"container":"container_2LxtI","loader":"loader_2nDHj","ant-spin-dot":"ant-spin-dot_2FjKL"};